export default __webpack_public_path__ + "static/media/fix-wp.147ace5d.webp";